import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import CamperVideoService from '../../api/services/CamperVideoService';
import MainPagetitle from '../../layouts/MainPagetitle';


const AddCamperVideo = () => {
  const navigate = useNavigate();
  const [error, setError] = useState([]);
  const [camper, setCamper] = useState([]);
  const [camperType,setCamperType] = useState([]);
  const [videoType, setVideoType] = useState([]);
  
  useEffect(() => {
    getCamper();
    getCamperType();
    getVideoType();

  }, []);
  // ----------- get Camper  ------------ //
  const getCamper = async () => {
    try {
      let brands = await CamperVideoService.camper_index().json();
      setCamper(brands.data);
    } catch (error) { 
      if (error.name === 'HTTPError') {
      const errorJson = await error.response.json();
      setError(errorJson.message.substr(0, errorJson.message.lastIndexOf(".")))
    }
    }
  };

  // ----------- get Camper Type  ------------ //
  const getCamperType = async () => {
    try {
      let fuel = await CamperVideoService.camperType().json();
      setCamperType(fuel.data);
    } catch (error) { 
      if (error.name === 'HTTPError') {
      const errorJson = await error.response.json();
      setError(errorJson.message.substr(0, errorJson.message.lastIndexOf(".")))
    }
    }
  };
   // ----------- get Video Type   ------------ //
  const getVideoType = async () => {
    try {
      let type = await CamperVideoService.videoType().json();
    setVideoType(type.data);
    } catch (error) {
      if (error.name === 'HTTPError') {
        const errorJson = await error.response.json();
        setError(errorJson.message.substr(0, errorJson.message.lastIndexOf(".")))
      }
    }
  };

  const onSubmitForm = async (event) => {
    event.preventDefault();
    setError("")
    try {
      var userData = {
          "video": event.target.video.value,
          "camper_id": event.target.camper_id.value,
          "camper_type_id": event.target.camper_type_id.value,
          "video_type_id": event.target.video_type_id.value,
          "description": event.target.description.value,
          
      }
      let responseData = await CamperVideoService.store(userData).json()
      if (responseData.status === true) {
       
        navigate("/admin/explanatory-videos");
      }
    } catch (error) {
        console.log(error)
      if (error.name === 'HTTPError') {
        const errorJson = await error.response.json();
        setError(errorJson.message.substr(0, errorJson.message.lastIndexOf(".")))
      }
      }
    
  };

  return (
    <>
      <MainPagetitle mainTitle="Add Camper Video" pageTitle={'Add Camper Video'} parentTitle={'Home'} />
      <div className="container-fluid">
            <div className="row">
                    <div className="col-xl-12">
                        <div className="card">
                            <div className="card-header">
                            <h4 className="card-title">Camper Explanatory Video</h4>
                            </div>
                            <div className="card-body">
                                <form className="form-valide" onSubmit={onSubmitForm}>
                                <div className="row">
                                    <div className="col-xl-12 mb-3">
                                        <label htmlFor="val-username" className="form-label" >Camper<span className="text-danger">*</span></label>
                                        <select className="form-control" id="val-skill" name="camper_id">
                                        {camper.map((row, index) =>
                                            <option key={index} value={row.id}>{row.title} </option>
                                        )}
                                        </select>

                                    </div>
                                    <div className="col-xl-12 mb-3">
                                        <label htmlFor="val-username" className="form-label" >Camper Type<span className="text-danger">*</span></label>
                                        <select className="form-control" id="val-skill" name="camper_type_id">
                                        {camperType.map((row, index) =>
                                            <option key={index} value={row.id}>{row.type} </option>
                                        )}
                                        </select>

                                    </div>
                                    <div className="col-xl-12 mb-3">
                                        <label htmlFor="val-username" className="form-label" >Explanatory Type<span className="text-danger">*</span></label>
                                        <select className="form-control" id="val-skill" name="video_type_id">
                                        {videoType.map((row, index) =>
                                            <option key={index} value={row.id}>{row.explanatory_type} </option>
                                        )}
                                        </select>

                                    </div>
                                    <div className="col-xl-12 mb-3">
                                        <label htmlFor="val-username" className="form-label" >Explanatory Video<span className="text-danger">*</span></label>
                                        <input type="text" className="form-control" name='video' id="val-username" placeholder="" />
                                    </div>
                                    <div className="col-xl-12 mb-3">
                                        <label className="form-label" htmlFor="val-suggestions">Description <span className="text-danger">*</span></label>
                                        <textarea rows="3"  id="val-suggestions" className="form-control" name='description'></textarea>
                                    </div>
                                </div>
                                <h5 style={{color:'red'}}>{error}</h5>
                                <div>
                                    <button type="submit" className="btn btn-primary me-1">Submit</button>
                                </div>
                            </form>
                            </div>
                        </div>
                    </div>
           
            </div>
        
      </div>

    </>
  );
};
export default AddCamperVideo;